import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ListEntityPicker } from '@work4all/components/lib/components/entity-picker/components/list-entity-picker/ListEntityPicker';
import {
  CONTACT_FIELDS,
  renderContact,
} from '@work4all/components/lib/components/entity-picker/contact-picker/ContactPicker';
import { IPickerProps } from '@work4all/components/lib/components/entity-picker/types';

import { Contact } from '@work4all/models/lib/Classes/Contact.entity';
import { Project } from '@work4all/models/lib/Classes/Project.entity';
import { EMode } from '@work4all/models/lib/Enums/EMode.enum';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';
import { FileType } from '@work4all/models/lib/File';

import { FileContext } from '../../../../../containers/files/detail/components/FileContext';

type ChronoContact =
  | Contact<EMode.entity>
  | { id: string | number; name: string };

export type ChronoContactPickerProps<TMultiple extends boolean> = IPickerProps<
  ChronoContact,
  TMultiple
>;

export function ChronoContactPicker<TMultiple extends boolean>(
  props: ChronoContactPickerProps<TMultiple>
) {
  const { ...rest } = props;
  const { t } = useTranslation();
  const fileContext = useContext(FileContext);
  const prefilter = useMemo(() => {
    if (isProject(fileContext.data, fileContext.type)) {
      return [
        {
          businessPartnerId: {
            $in: [
              fileContext.data?.supplier?.id,
              fileContext.data?.customer?.id,
            ].filter((x) => x),
          },
        },
      ];
    }
    return [{ businessPartnerId: { $eq: fileContext.id } }];
  }, [fileContext]);

  return (
    <ListEntityPicker
      entity={Entities.contact}
      data={CONTACT_FIELDS}
      filterBy="displayName"
      sortBy="displayName"
      clearable={true}
      {...rest}
      prefilter={prefilter}
      renderItemContent={renderContact(null, t)}
    />
  );
}

function isProject(data: unknown, type: FileType): data is Project {
  return type === FileType.PROJECT;
}
